import { gql } from '@apollo/client';

export const EXPORT_MA_TRANSACTIONS_ENDPOINT = 'm-a/export-transactions';

export const MA_TRANSACTIONS_QUERY = gql`
  query maTransactions($filters: MaFilters, $pagination: PaginationInput) {
    maTransactions(filters: $filters, pagination: $pagination) {
      totalCount
      transactions {
        id
        assetName
        shoreStatus
        workingInterest
        weaWorkingInterestReserves
        weaWorkingInterestProduction
        weaWorkingInterestValuation
        weaWorkingInterestLiquidsReserves
        weaWorkingInterestGasReserves
        weaWorkingInterestLiquidsProduction
        weaWorkingInterestGasProduction
        weaCurrentEmissionsIntensity
        weaRemainingEmissionsIntensity

        weaPriceFlowingBarrel
        weaReservesAcquisitionCost

        country {
          id
          displayName
          region {
            id
            displayName
          }
        }

        maCompanyTransaction {
          id
          buyerCompanyName
          sellerCompanyName

          maDeal {
            id
            dealType
            effectiveDate
            comment

            maDealDetails {
              id
              acreage
              announcementDate
              closingDate
              dealStatus
              sellerMotivation
              sellSideAdvisor
              buySideAdvisor
              paymentType
              reportedConsiderationComment
              reportedConsiderationBaseCashMmusd
              reportedConsiderationBaseEquityMmusd
              reportedConsiderationContingentMmusd
              reportedDebtMmusd
              reportedCostCarryMmusd
              reportedConsiderationTotalMmusd
              reportedSignatureBonusMmusd
              reportedCostCommitmentMmusd
              reportedTransacted1pReservesMmboe
              reportedTransacted1pOilCondensateReservesMmbbl
              reportedTransacted1pGasReservesBcf
              reportedTransacted2pReservesMmboe
              reportedTransacted2pOilCondensateReservesMmbbl
              reportedTransacted2pGasReservesBcf
              reportedTransacted2cResourceMmboe
              reportedTransacted2cOilCondensateResourceMmbbl
              reportedTransacted2cGasResourceBcf
              reportedProductionBoed
              reportedOilCondensateProductionBbld
              reportedGasProductionMmcfd
              reportedReservesAcquisitionCostUsdPerBoe
              reportedAcreageAcquisitionCostUsdPerAcre
              reportedPricePerFlowingBarrelUsdPerBoed
              reportedCurrentEmissionsIntensityKgco2ePerBoe
              reportedRemainingEmissionsIntensityKgco2ePerBoe
            }
          }
        }
      }
    }
  }
`;

export const MA_DEALS_PAGINATED_QUERY = gql`
  query maDeals($filters: MaFilters, $pagination: PaginationInput) {
    maDeals(filters: $filters, pagination: $pagination) {
      totalCount
      deals {
        id
        dealType
        comment
        effectiveDate

        dealBuyerCompanyName
        dealSellerCompanyName

        dealAssetName
        dealShoreStatus
        dealWorkingInterest
        dealWorkingInterestReserves
        dealWorkingInterestProduction
        dealWorkingInterestValuation
        dealWorkingInterestLiquidsReserves
        dealWorkingInterestGasReserves
        dealWorkingInterestLiquidsProduction
        dealWorkingInterestGasProduction
        dealCurrentEmissionsIntensity
        dealRemainingEmissionsIntensity

        dealReservesAcquisitionCost
        dealPriceFlowingBarrel
        dealConsiderationByProduction
        dealConsiderationByReserves

        dealCountryName
        dealRegionName

        maAssetTransactionsCount
        maCompanyTransactionsCount

        maDealDetails {
          id
          acreage
          announcementDate
          closingDate
          dealStatus
          sellerMotivation
          sellSideAdvisor
          buySideAdvisor
          paymentType
          reportedConsiderationComment
          reportedConsiderationBaseCashMmusd
          reportedConsiderationBaseEquityMmusd
          reportedConsiderationContingentMmusd
          reportedDebtMmusd
          reportedCostCarryMmusd
          reportedConsiderationTotalMmusd
          reportedSignatureBonusMmusd
          reportedCostCommitmentMmusd
          reportedTransacted1pReservesMmboe
          reportedTransacted1pOilCondensateReservesMmbbl
          reportedTransacted1pGasReservesBcf
          reportedTransacted2pReservesMmboe
          reportedTransacted2pOilCondensateReservesMmbbl
          reportedTransacted2pGasReservesBcf
          reportedTransacted2cResourceMmboe
          reportedTransacted2cOilCondensateResourceMmbbl
          reportedTransacted2cGasResourceBcf
          reportedProductionBoed
          reportedOilCondensateProductionBbld
          reportedGasProductionMmcfd
          reportedReservesAcquisitionCostUsdPerBoe
          reportedAcreageAcquisitionCostUsdPerAcre
          reportedPricePerFlowingBarrelUsdPerBoed
          reportedCurrentEmissionsIntensityKgco2ePerBoe
          reportedRemainingEmissionsIntensityKgco2ePerBoe
        }
      }
    }
  }
`;
